import { Helmet } from 'react-helmet';
import SecNavbar from '../../components/light/services-details/SecNavbar';
import Footer from '../../components/light/creative-agency/Footer';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import AiExploreBar from '../../components/light/ai/AiExploreBar';
import AiSectionGallery from '../../components/light/ai/AiSectionGallery';
import '../../components/light/ai/aiStyles.css';

const images = [
  '3.jpg',
  '6.jpg',
  '7 (1).jpg',
  '7.jpg',
  '9.jpg',
  '11.jpg',
  '0990d315-e863-4d64-b9b1-e580ea19d26d.png_202605151739.jpeg',
  'Red-Wine-Soap.jpg_202605141929.jpeg',
  'Untitled design (1).jpg',
  'Untitled design.jpg',
  'gold_necklace_and_earrings_displayed_202605151736.jpeg',
  'Use_the_provided_reference_image_202605151734 (1).jpeg',
  'Use_the_provided_reference_image_202605151734.jpeg',
  '_USE_PROVIDED_IMAGE_AS_REFERENCE__202605151740.jpeg',
]
  .filter((fileName, idx, arr) => arr.findIndex((y) => y === fileName) === idx)
  .map((fileName) => ({
    fileName,
    src: `/light/assets/ai/Product Shoot/${encodeURIComponent(fileName)}`,
  }));

export default function PageAiProductShoot() {
  return (
    <>
      <Helmet>
        <title>Aashway | AI Product Shoot</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <Cursor />
        <ProgressScroll />
        <Lines />

        <div id="smooth-wrapper">
          <SecNavbar />
          <div id="smooth-content">
            <main className="main-bg">
              {/* Header section matching other service layouts */}
              <div
                className="header page-header bg-img section-padding"
                data-background="/light/assets/imgs/header/b5.jpg"
                data-overlay-dark="9"
                style={{ backgroundImage: 'url("/light/assets/imgs/header/b5.jpg")' }}
              >
                <div className="container pt-100">
                  <div className="text-center">
                    <h1 className="fz-100 text-u">Product Shoot</h1>
                    <div className="mt-15">
                      <a href="/">Home</a>
                      <span className="padding-rl-20">|</span>
                      <a href="/light/page-ai">AI</a>
                      <span className="padding-rl-20">|</span>
                      <span className="main-color">Product Shoot</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sub-navigation bar */}
              <div className="container mt-40">
                <AiExploreBar active="product" />
              </div>

              {/* Gallery section */}
              <section className="ai-section-wrap pt-40">
                <div className="container">
                  <AiSectionGallery videos={[]} images={images} />
                </div>
              </section>
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}

